import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { displayLabel } from "../../utils/displayLabel";
import { selectDiscoveryBooks } from "../../utils/discoveryBooks";
export default function DiscoveryShelf() {
  const [books, setBooks] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    fetch("https://bookish-master-data.s3.us-west-2.amazonaws.com/market.json", { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error("Catalog unavailable"); return response.json(); })
      .then(data => {
        setBooks(selectDiscoveryBooks(data.books));
      }).catch(() => {});
    return () => controller.abort();
  }, []);
  return <div className="discovery-shelf"><p className="public-eyebrow">Independent voices. New worlds.</p>
    {books.length ? <div className="discovery-covers">{books.map(book => <a key={book.productUrl} href={book.productUrl}><img src={book.coverImageUrl || book.formats.find(format => format.coverImageUrl).coverImageUrl} alt={displayLabel(book.title)} onError={event => { event.currentTarget.style.visibility = "hidden"; }} /><span>{displayLabel(book.authorName)}</span></a>)}</div> : <div className="shelf-fallback"><span aria-hidden="true">✦</span><p>Your next favorite story<br />is waiting to be found.</p><Link to="/market">Explore the bookshop →</Link></div>}
    <p className="shelf-caption">A selection from our independent authors. <Link to="/market">Explore all books →</Link></p></div>;
}
